export default __webpack_public_path__ + "static/media/katana left.a473b9c2.png";